module.exports = __webpack_public_path__ + "static/media/product-listing.d0b219b6.svg";